<template>
  <div class="l-data-board l-rblock" v-loading="loading">
    <div
      v-if="showType == 'icon'"
      :class="['l-data-board__icon']"
      :style="{ color: color }"
    >
      <div
        class="l-data-board__icon__bg"
        :style="{ 'background-color': color }"
      ></div>
      <i :class="icon"></i>
    </div>
    <div v-if="showType == 'img'" :class="['l-data-board__icon']">
      <el-image class="img" :src="imgUrl">
        <div slot="error" class="image-slot">
          <i class="el-icon-picture-outline"></i>
        </div>
      </el-image>
    </div>
    <div class="l-data-board__text">
      <div v-if="label" class="l-data-board__title">{{ label }}</div>
      <div class="l-data-board__num" :style="{ color: numColor }">
        <l-count-up :end="showValue"></l-count-up>
        <span>{{ valueDw }}</span>
      </div>
      <div v-if="des" class="l-data-board__des">
        {{ des }}
        <i
          v-if="flagIcon"
          :style="{ color: flagIconColor }"
          :class="['flag-icon', flagIcon]"
        ></i>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "l-data-board",
  props: {
    value: [Number, String],
    label: String,
    des: String,

    showType: String,
    icon: String,
    color: String,
    imgUrl: String,

    numColor: {
      type: String,
      default: "#5E95FF",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    flagIcon: String,
    flagIconColor: String,
  },
  data() {
    return {};
  },
  computed: {
    showValue() {
      let num = this.value;
      if (this.value && typeof this.value == "string") {
        num = this.value.replace(/[^0-9]/gi, "");
        num = parseFloat(num);
      }
      return num;
    },
    valueDw() {
      // 值单位
      if (
        this.value &&
        typeof this.value == "string" &&
        this.value.indexOf(this.showValue + "") > -1
      ) {
        return this.value.replace(this.showValue + "", "");
      }
      return "";
    },
  },
};
</script>

<style lang="less">
@import "./index.less";
</style>
